import { render, staticRenderFns } from "./SortTwo.vue?vue&type=template&id=57aa3fe7"
import script from "./SortTwo.vue?vue&type=script&lang=js"
export * from "./SortTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports